import { render } from "./PublicEventParticipationPreview.vue?vue&type=template&id=28534ef1&ts=true"
import script from "./PublicEventParticipationPreview.vue?vue&type=script&lang=ts"
export * from "./PublicEventParticipationPreview.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__